import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-empty-search",
  "use": "icon-empty-search-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" fill=\"none\" id=\"icon-empty-search\">\n  <circle cx=\"27\" cy=\"27\" r=\"16.5\" stroke=\"#C5C9D1\" stroke-width=\"3\" />\n  <line x1=\"38.8\" y1=\"38.8\" x2=\"51\" y2=\"51\" stroke=\"#C5C9D1\" stroke-width=\"3.2\" stroke-linecap=\"round\" />\n  <line x1=\"20.5\" y1=\"27\" x2=\"33.5\" y2=\"27\" stroke=\"#DCDFE5\" stroke-width=\"3\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol